export const lightTheme = {
  body: '#FAFAFA',
  primary: '#2196F3',
  text: '#323232',
  textGreyOne: '#A8A8A8',
  textGreyTwo: '#D6D6D6',
  backgroundCard: '#FFF',
  colorShadow: 'rgb(33 150 243 / 0.16)'
}

export const darkTheme = {
  body: '#191919',
  primary: '#2196F3',
  text: '#FAFAFA',
  textGreyOne: '#A8A8A8',
  textGreyTwo: '#393737',
  backgroundCard: '#1D1C1C',
  colorShadow: 'rgb(0 0 0 / 0.16)'
}

export const LIGHT = 'light'
export const DARK = 'dark'
